/* eslint react/prop-types:0 */
import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { MainLayout } from '@confluence/main-layout';
import { Screen } from '@confluence/screen';

import { Marketplace } from './MarketplaceRouteComponent';

export const MarketplacePromotionsRoute = ({ name }) => (
	<Screen
		screenEvent={{
			name: 'marketplacePromotions',
			id: 'marketplacePromotions',
		}}
		pageState={{
			routeName: name,
		}}
	>
		<MainLayout navView={ADMIN_HOME_ID}>
			<Marketplace />
		</MainLayout>
	</Screen>
);
